import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faCamera } from "@fortawesome/free-solid-svg-icons";

const UserAttributionPill = ({
  username,
  date,
  profilePic,
  type = "spotted", // "spotted" or "added"
  className = "",
}) => {
  if (!username) return null;

  return (
    <Link
      to={`/u/${username}`}
      className={`group inline-flex items-center gap-2 text-xs transition-all duration-200 max-w-[180px] ${className}`}
      title={`First ${type} by ${username}`}
    >
      {profilePic ? (
        <img src={profilePic} alt={username} className="w-4 h-4 rounded-full" />
      ) : (
        <div className="w-4 h-4 rounded-full bg-gray-200 flex items-center justify-center dark:bg-gray-700">
          <span className="text-xs text-gray-500 dark:text-gray-400">
            {username.charAt(0).toUpperCase()}
          </span>
        </div>
      )}
      <div className="overflow-hidden whitespace-nowrap">
        <span className="font-medium text-gray-900 group-hover:text-blue-600 transition-colors inline-block animate-scroll dark:text-gray-100">
          {username}
        </span>
      </div>
      <span className="text-xs text-gray-500 flex items-center gap-1 dark:text-gray-400">
        <FontAwesomeIcon
          icon={type === "spotted" ? faCar : faCamera}
          className="text-gray-400 w-3.5 h-3.5 dark:text-gray-400"
        />
        {new Date(date).toLocaleDateString()}
      </span>
    </Link>
  );
};

export default UserAttributionPill;
